<template>
  <b-tab>
    <template v-slot:title>Loans</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Loans</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_loans == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_loans')" />
          <RockerSwitch v-else :value="false" @change="changePermission(role = item.role, permission = 'view_loans')" />
        </div>
      </div>

      <!-- Sub Tabs -->
      <div class="my-3 d-flex justify-content-evenly">
        <button @click.prevent="current_tab = 1" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 1 }">Applications</button>
        <button @click.prevent="current_tab = 2" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 2 }">Disbursements</button>
        <button @click.prevent="current_tab = 3" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 3 }">Running</button>
        <button @click.prevent="current_tab = 4" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 4 }">Other</button>
      </div>
      <hr>

      <!-- Loan Applications -->
      <div v-show="current_tab == 1">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Applications</div>
          <div class="col-2">Add New Applications</div>
          <div class="col-2">Approve Applications</div>
          <div class="col-2">Delete Applications</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Applications -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_loanapplications == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_loanapplications')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_loanapplications')" />
          </div>

          <!-- New Applications -->
          <div class="col-2">
            <RockerSwitch v-if="item.new_loanapplications == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_loanapplications')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_loanapplications')" />
          </div>

          <!-- Approve Applications -->
          <div class="col-2">
            <RockerSwitch v-if="item.approve_loanapplications == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'approve_loanapplications')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'approve_loanapplications')" />
          </div>

          <!-- Delete Applications -->
          <div class="col-2">
            <RockerSwitch v-if="item.delete_loanapplications == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_loanapplications')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_loanapplications')" />
          </div>
        </div>
      </div>

      <!-- Loan Disbursements -->
      <div v-show="current_tab == 2">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-3">View Disbursements</div>
          <div class="col-3">Approve Disbursements</div>
          <div class="col-3">Decline Disbursements</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Disbursements -->
          <div class="col-3">
            <RockerSwitch v-if="item.view_loandisbursement == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_loandisbursement')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_loandisbursement')" />
          </div>

          <!-- Approve Disbursements -->
          <div class="col-3">
            <RockerSwitch v-if="item.approve_loandisbursement == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'approve_loandisbursement')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'approve_loandisbursement')" />
          </div>

          <!-- Delete Disbursements -->
          <div class="col-3">
            <RockerSwitch v-if="item.decline_loandisbursement == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'decline_loandisbursement')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'decline_loandisbursement')" />
          </div>
        </div>
      </div>

      <!-- Running Loans -->
      <div v-show="current_tab == 3">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Running Loans</div>
          <div class="col-2">Close Running Loans</div>
          <div class="col-2">Make Loan Payments</div>
          <div class="col-2">Reschedule a Loan</div>
          <div class="col-2">Write off Loan</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Running Loans -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_runningloans == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_runningloans')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_runningloans')" />
          </div>

          <!-- Close Running Loans -->
          <div class="col-2">
            <RockerSwitch v-if="item.close_runningloans == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'close_runningloans')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'close_runningloans')" />
          </div>

          <!-- Make Loan Payments -->
          <div class="col-2">
            <RockerSwitch v-if="item.repayaloan == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'repayaloan')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'repayaloan')" />
          </div>

          <!-- Reschedule Loans -->
          <div class="col-2">
            <RockerSwitch v-if="item.reschedule_loan == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'reschedule_loan')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'reschedule_loan')" />
          </div>

          <!-- Write off Loans -->
          <div class="col-2">
            <RockerSwitch v-if="item.write_off_loan == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'write_off_loan')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'write_off_loan')" />
          </div>
        </div>
      </div>

      <!-- Other Loan Settings -->
      <div v-show="current_tab == 4">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-3">View Closed Loans</div>
          <div class="col-3">View Loan Arrears</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Running Loans -->
          <div class="col-3">
            <RockerSwitch v-if="item.view_closedloans == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_closedloans')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_closedloans')" />
          </div>

          <!-- Close Running Loans -->
          <div class="col-3">
            <RockerSwitch v-if="item.view_loanarrears == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_loanarrears')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_loanarrears')" />
          </div>

        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "LoanPermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
      current_tab: 1,
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_loans == 1);
    },
  },
  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>